export default {
	PRODUCT: 'Product',
	ASSETS: 'Assets',
	PRODUCT_VARIANTS: 'Product variants',
	TILE_LAYOUTS: 'Layouts',
	TRANSLATIONS: 'Translations',
};
